var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"choose-logo-color"},[_c('div',{staticClass:"gap"}),_c('strong',[_vm._v("Logo-Farbe")]),_c('div',{staticClass:"gap"}),_c('Colors',{attrs:{"colors":_vm.colors,"active-color":_vm.currentLogoColor},on:{"setColor":_vm.setColor}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }